export default {"src":"/_next/static/media/apple-app-badge.8e3b7de3.svg","height":48,"width":145};